import React from 'react'
import * as Errors from '@morningtrain/react-errors'
import * as Displays from 'support/displays'
import { WhenModelValue } from '@morningtrain/react-resources'
import CartTotal from 'services/cart/CartTotal'
import WhenCartIsNotEmpty from 'services/cart/conditionals/WhenCartIsNotEmpty'

export default function CartBanner (props) {
  return (
    <WhenCartIsNotEmpty>
      <Errors.Boundary>
        {/* Spacer so banner isn't overlapping content */}
        <div className='h-24' />
        {/* Cart banner */}
        <div className='bg-primary-500 text-white fixed left-0 right-0 bottom-0 px-6 py-4 flex justify-between items-center md:left-64 sm:px-12 sm:py-5'>
          <div className='mr-2 sm:flex sm:items-center'>
            <CartTotal>
              <div>
                <p className='sm:text-lg'>
                  <Displays.Text name='totalCount' /> stk.
                </p>
              </div>
            </CartTotal>
          </div>
          {props.children}
        </div>
      </Errors.Boundary>
    </WhenCartIsNotEmpty>
  )
}
